<template lang="html">
  <div class="model">
    <div class="model-body">
      <div class="model-header">
        请选择国际电话区号
      </div>
      <div class="model-content">
        <div v-for="item of list" @click="selectKey(item.value)" :key="item.name" class="model-item">
          <div class="">
            <span>{{item.label}}</span>
            <span class="code">+{{item.value}}</span>
          </div>
          <img v-if="getChecked(item.value)" src="../assets/images/checked.svg" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: String,
      default: '86'
    },
    change: {
      type: Function
    }
  },
  data () {
    return {
      list: [
        { en: 'China', label: '中国', name: 'ZN', value: '86' },
        { en: 'Hong Kong', label: '中国香港', name: 'HK', value: '852' },
        { en: 'Macau', label: '中国澳门', name: 'MO', value: '853' },
        { en: 'Taiwan', label: '中国台湾', name: 'TW', value: '886' },
        { en: 'United Kingdom', label: '英国', name: 'GB', value: '44' },
        { en: 'United States', label: '美国', name: 'US', value: '1' },
        { en: 'Japan', label: '日本', name: 'JP', value: '81' },
        { en: 'Australia', label: '澳大利亚', name: 'AU', value: '61' },
        { en: 'Malaysia', label: '马来西亚', name: 'MY', value: '60' },
        { en: 'New Zealand', label: '新西兰', name: 'NZ', value: '64' },
        { en: 'France', label: '法国', name: 'FR', value: '33' },
        { en: 'Afghanistan', label: '阿富汗', name: 'AF', value: '93' },
        { en: 'Albania', label: '阿尔巴尼亚', name: 'AL', value: '355' },
        { en: 'Algeria', label: '阿尔及利亚', name: 'DZ', value: '213' },
        { en: 'American Samoa', label: '美属萨摩亚', name: 'AS', value: '1684' },
        { en: 'Andorra', label: '安道尔', name: 'AD', value: '376' },
        { en: 'Angola', label: '安哥拉', name: 'AO', value: '244' },
        { en: 'Anguilla', label: '安圭拉', name: 'AI', value: '1264' },
        { en: 'Antigua and Barbuda', label: '安提瓜和巴布达', name: 'AG', value: '1268' },
        { en: 'Argentina', label: '阿根廷', name: 'AR', value: '54' },
        { en: 'Armenia', label: '亚美尼亚', name: 'AM', value: '374' },
        { en: 'Aruba', label: '阿鲁巴', name: 'AW', value: '297' },
        { en: 'Austria', label: '奥地利', name: 'AT', value: '43' },
        { en: 'Azerbaijan', label: '阿塞拜疆', name: 'AZ', value: '994' },
        { en: 'Bahamas', label: '巴哈马', name: 'BS', value: '1242' },
        { en: 'Bahrain', label: '巴林', name: 'BH', value: '973' },
        { en: 'Bangladesh', label: '孟加拉国', name: 'BD', value: '880' },
        { en: 'Barbados', label: '巴巴多斯', name: 'BB', value: '1246' },
        { en: 'Belarus', label: '白俄罗斯', name: 'BY', value: '375' },
        { en: 'Belgium', label: '比利时', name: 'BE', value: '32' },
        { en: 'Belize', label: '伯利兹', name: 'BZ', value: '501' },
        { en: 'Benin', label: '贝宁', name: 'BJ', value: '229' },
        { en: 'Bermuda', label: '百慕大群岛', name: 'BM', value: '1441' },
        { en: 'Bhutan', label: '不丹', name: 'BT', value: '975' },
        { en: 'Bolivia', label: '玻利维亚', name: 'BO', value: '591' },
        { en: 'Bosnia and Herzegovina', label: '波斯尼亚和黑塞哥维那', name: 'BA', value: '387' },
        { en: 'Botswana', label: '博茨瓦纳', name: 'BW', value: '267' },
        { en: 'Brazil', label: '巴西', name: 'BR', value: '55' },
        { en: 'Brunei', label: '文莱', name: 'BN', value: '673' },
        { en: 'Bulgaria', label: '保加利亚', name: 'BG', value: '359' },
        { en: 'Burkina Faso', label: '布基纳法索', name: 'BF', value: '226' },
        { en: 'Burundi', label: '布隆迪', name: 'BI', value: '257' },
        { en: 'Cambodia', label: '柬埔寨', name: 'KH', value: '855' },
        { en: 'Cameroon', label: '喀麦隆', name: 'CM', value: '237' },
        { en: 'Canada', label: '加拿大', name: 'CA', value: '1' },
        { en: 'Cape Verde', label: '开普', name: 'CV', value: '238' },
        { en: 'Cayman Islands', label: '开曼群岛', name: 'KY', value: '1345' },
        { en: 'Central African Republic', label: '中非共和国', name: 'CF', value: '236' },
        { en: 'Chad', label: '乍得', name: 'TD', value: '235' },
        { en: 'Chile', label: '智利', name: 'CL', value: '56' },
        { en: 'Colombia', label: '哥伦比亚', name: 'CO', value: '57' },
        { en: 'Comoros', label: '科摩罗', name: 'KM', value: '269' },
        { en: 'Cook Islands', label: '库克群岛', name: 'CK', value: '682' },
        { en: 'Costa Rica', label: '哥斯达黎加', name: 'CR', value: '506' },
        { en: 'Croatia', label: '克罗地亚', name: 'HR', value: '385' },
        { en: 'Cuba', label: '古巴', name: 'CU', value: '53' },
        { en: 'Curacao', label: '库拉索', name: 'CW', value: '599' },
        { en: 'Cyprus', label: '塞浦路斯', name: 'CY', value: '357' },
        { en: 'Czech', label: '捷克', name: 'CZ', value: '420' },
        { en: 'Democratic Republic of the Congo', label: '刚果民主共和国', name: 'CD', value: '243' },
        { en: 'Denmark', label: '丹麦', name: 'DK', value: '45' },
        { en: 'Djibouti', label: '吉布提', name: 'DJ', value: '253' },
        { en: 'Dominica', label: '多米尼加', name: 'DM', value: '1767' },
        { en: 'Dominican Republic', label: '多米尼加共和国', name: 'DO', value: '1809' },
        { en: 'Ecuador', label: '厄瓜多尔', name: 'EC', value: '593' },
        { en: 'Egypt', label: '埃及', name: 'EG', value: '20' },
        { en: 'El Salvador', label: '萨尔瓦多', name: 'SV', value: '503' },
        { en: 'Equatorial Guinea', label: '赤道几内亚', name: 'GQ', value: '240' },
        { en: 'Eritrea', label: '厄立特里亚', name: 'ER', value: '291' },
        { en: 'Estonia', label: '爱沙尼亚', name: 'EE', value: '372' },
        { en: 'Ethiopia', label: '埃塞俄比亚', name: 'ET', value: '251' },
        { en: 'Faroe Islands', label: '法罗群岛', name: 'FO', value: '298' },
        { en: 'Fiji', label: '斐济', name: 'FJ', value: '679' },
        { en: 'Finland', label: '芬兰', name: 'FI', value: '358' },
        { en: 'French Guiana', label: '法属圭亚那', name: 'GF', value: '594' },
        { en: 'French Polynesia', label: '法属波利尼西亚', name: 'PF', value: '689' },
        { en: 'Gabon', label: '加蓬', name: 'GA', value: '241' },
        { en: 'Gambia', label: '冈比亚', name: 'GM', value: '220' },
        { en: 'Georgia', label: '格鲁吉亚', name: 'GE', value: '995' },
        { en: 'Germany', label: '德国', name: 'DE', value: '49' },
        { en: 'Ghana', label: '加纳', name: 'GH', value: '233' },
        { en: 'Gibraltar', label: '直布罗陀', name: 'GI', value: '350' },
        { en: 'Greece', label: '希腊', name: 'GR', value: '30' },
        { en: 'Greenland', label: '格陵兰岛', name: 'GL', value: '299' },
        { en: 'Grenada', label: '格林纳达', name: 'GD', value: '1473' },
        { en: 'Guadeloupe', label: '瓜德罗普岛', name: 'GP', value: '590' },
        { en: 'Guam', label: '关岛', name: 'GU', value: '1671' },
        { en: 'Guatemala', label: '瓜地马拉', name: 'GT', value: '502' },
        { en: 'Guinea', label: '几内亚', name: 'GN', value: '224' },
        { en: 'Guinea-Bissau', label: '几内亚比绍共和国', name: 'GW', value: '245' },
        { en: 'Guyana', label: '圭亚那', name: 'GY', value: '592' },
        { en: 'Haiti', label: '海地', name: 'HT', value: '509' },
        { en: 'Honduras', label: '洪都拉斯', name: 'HN', value: '504' },
        { en: 'Hungary', label: '匈牙利', name: 'HU', value: '36' },
        { en: 'Iceland', label: '冰岛', name: 'IS', value: '354' },
        { en: 'India', label: '印度', name: 'IN', value: '91' },
        { en: 'Indonesia', label: '印度尼西亚', name: 'ID', value: '62' },
        { en: 'Iran', label: '伊朗', name: 'IR', value: '98' },
        { en: 'Iraq', label: '伊拉克', name: 'IQ', value: '964' },
        { en: 'Ireland', label: '爱尔兰', name: 'IE', value: '353' },
        { en: 'Israel', label: '以色列', name: 'IL', value: '972' },
        { en: 'Italy', label: '意大利', name: 'IT', value: '39' },
        { en: 'Ivory Coast', label: '象牙海岸', name: 'CI', value: '225' },
        { en: 'Jamaica', label: '牙买加', name: 'JM', value: '1876' },
        { en: 'Jordan', label: '约旦', name: 'JO', value: '962' },
        { en: 'Kazakhstan', label: '哈萨克斯坦', name: 'KZ', value: '7' },
        { en: 'Kenya', label: '肯尼亚', name: 'KE', value: '254' },
        { en: 'Kiribati', label: '基里巴斯', name: 'KI', value: '686' },
        { en: 'Kuwait', label: '科威特', name: 'KW', value: '965' },
        { en: 'Kyrgyzstan', label: '吉尔吉斯斯坦', name: 'KG', value: '996' },
        { en: 'Laos', label: '老挝', name: 'LA', value: '856' },
        { en: 'Latvia', label: '拉脱维亚', name: 'LV', value: '371' },
        { en: 'Lebanon', label: '黎巴嫩', name: 'LB', value: '961' },
        { en: 'Lesotho', label: '莱索托', name: 'LS', value: '266' },
        { en: 'Liberia', label: '利比里亚', name: 'LR', value: '231' },
        { en: 'Libya', label: '利比亚', name: 'LY', value: '218' },
        { en: 'Liechtenstein', label: '列支敦士登', name: 'LI', value: '423' },
        { en: 'Lithuania', label: '立陶宛', name: 'LT', value: '370' },
        { en: 'Luxembourg', label: '卢森堡', name: 'LU', value: '352' },
        { en: 'Macedonia', label: '马其顿', name: 'MK', value: '389' },
        { en: 'Madagascar', label: '马达加斯加', name: 'MG', value: '261' },
        { en: 'Malawi', label: '马拉维', name: 'MW', value: '265' },
        { en: 'Maldives', label: '马尔代夫', name: 'MV', value: '960' },
        { en: 'Mali', label: '马里', name: 'ML', value: '223' },
        { en: 'Malta', label: '马耳他', name: 'MT', value: '356' },
        { en: 'Martinique', label: '马提尼克', name: 'MQ', value: '596' },
        { en: 'Mauritania', label: '毛里塔尼亚', name: 'MR', value: '222' },
        { en: 'Mauritius', label: '毛里求斯', name: 'MU', value: '230' },
        { en: 'Mayotte', label: '马约特', name: 'YT', value: '269' },
        { en: 'Mexico', label: '墨西哥', name: 'MX', value: '52' },
        { en: 'Moldova', label: '摩尔多瓦', name: 'MD', value: '373' },
        { en: 'Monaco', label: '摩纳哥', name: 'MC', value: '377' },
        { en: 'Mongolia', label: '蒙古', name: 'MN', value: '976' },
        { en: 'Montenegro', label: '黑山', name: 'ME', value: '382' },
        { en: 'Montserrat', label: '蒙特塞拉特岛', name: 'MS', value: '1664' },
        { en: 'Morocco', label: '摩洛哥', name: 'MA', value: '212' },
        { en: 'Mozambique', label: '莫桑比克', name: 'MZ', value: '258' },
        { en: 'Myanmar', label: '缅甸', name: 'MM', value: '95' },
        { en: 'Namibia', label: '纳米比亚', name: 'NA', value: '264' },
        { en: 'Nepal', label: '尼泊尔', name: 'NP', value: '977' },
        { en: 'Netherlands', label: '荷兰', name: 'NL', value: '31' },
        { en: 'New Caledonia', label: '新喀里多尼亚', name: 'NC', value: '687' },
        { en: 'Nicaragua', label: '尼加拉瓜', name: 'NI', value: '505' },
        { en: 'Niger', label: '尼日尔', name: 'NE', value: '227' },
        { en: 'Nigeria', label: '尼日利亚', name: 'NG', value: '234' },
        { en: 'Norway', label: '挪威', name: 'NO', value: '47' },
        { en: 'Oman', label: '阿曼', name: 'OM', value: '968' },
        { en: 'Pakistan', label: '巴基斯坦', name: 'PK', value: '92' },
        { en: 'Palau', label: '帕劳', name: 'PW', value: '680' },
        { en: 'Palestine', label: '巴勒斯坦', name: 'BL', value: '970' },
        { en: 'Panama', label: '巴拿马', name: 'PA', value: '507' },
        { en: 'Papua New Guinea', label: '巴布亚新几内亚', name: 'PG', value: '675' },
        { en: 'Paraguay', label: '巴拉圭', name: 'PY', value: '595' },
        { en: 'Peru', label: '秘鲁', name: 'PE', value: '51' },
        { en: 'Philippines', label: '菲律宾', name: 'PH', value: '63' },
        { en: 'Poland', label: '波兰', name: 'PL', value: '48' },
        { en: 'Portugal', label: '葡萄牙', name: 'PT', value: '351' },
        { en: 'Puerto Rico', label: '波多黎各', name: 'PR', value: '1787' },
        { en: 'Qatar', label: '卡塔尔', name: 'QA', value: '974' },
        { en: 'Republic Of The Congo', label: '刚果共和国', name: 'CG', value: '242' },
        { en: 'Réunion Island', label: '留尼汪', name: 'RE', value: '262' },
        { en: 'Romania', label: '罗马尼亚', name: 'RO', value: '40' },
        { en: 'Russia', label: '俄罗斯', name: 'RU', value: '7' },
        { en: 'Rwanda', label: '卢旺达', name: 'RW', value: '250' },
        { en: 'Saint Kitts and Nevis', label: '圣基茨和尼维斯', name: 'KN', value: '1869' },
        { en: 'Saint Lucia', label: '圣露西亚', name: 'LC', value: '1758' },
        { en: 'Saint Pierre and Miquelon', label: '圣彼埃尔和密克隆岛', name: 'PM', value: '508' },
        { en: 'Saint Vincent and The Grenadines', label: '圣文森特和格林纳丁斯', name: 'VC', value: '1784' },
        { en: 'Samoa', label: '萨摩亚', name: 'WS', value: '685' },
        { en: 'San Marino', label: '圣马力诺', name: 'SM', value: '378' },
        { en: 'Sao Tome and Principe', label: '圣多美和普林西比', name: 'ST', value: '239' },
        { en: 'Saudi Arabia', label: '沙特阿拉伯', name: 'SA', value: '966' },
        { en: 'Senegal', label: '塞内加尔', name: 'SN', value: '221' },
        { en: 'Serbia', label: '塞尔维亚', name: 'RS', value: '381' },
        { en: 'Seychelles', label: '塞舌尔', name: 'SC', value: '248' },
        { en: 'Sierra Leone', label: '塞拉利昂', name: 'SL', value: '232' },
        { en: 'Singapore', label: '新加坡', name: 'SG', value: '65' },
        { en: 'Saint Maarten (Dutch Part)', label: '圣马丁岛（荷兰部分）', name: 'SX', value: '1721' },
        { en: 'Slovakia', label: '斯洛伐克', name: 'SK', value: '421' },
        { en: 'Slovenia', label: '斯洛文尼亚', name: 'SI', value: '386' },
        { en: 'Solomon Islands', label: '所罗门群岛', name: 'SB', value: '677' },
        { en: 'Somalia', label: '索马里', name: 'SO', value: '252' },
        { en: 'South Africa', label: '南非', name: 'ZA', value: '27' },
        { en: 'South Korea', label: '韩国', name: 'KR', value: '82' },
        { en: 'Spain', label: '西班牙', name: 'ES', value: '34' },
        { en: 'Sri Lanka', label: '斯里兰卡', name: 'LK', value: '94' },
        { en: 'Sudan', label: '苏丹', name: 'SD', value: '249' },
        { en: 'Suriname', label: '苏里南', name: 'SR', value: '597' },
        { en: 'Swaziland', label: '斯威士兰', name: 'SZ', value: '268' },
        { en: 'Sweden', label: '瑞典', name: 'SE', value: '46' },
        { en: 'Switzerland', label: '瑞士', name: 'CH', value: '41' },
        { en: 'Syria', label: '叙利亚', name: 'SY', value: '963' },
        { en: 'Tajikistan', label: '塔吉克斯坦', name: 'TJ', value: '992' },
        { en: 'Tanzania', label: '坦桑尼亚', name: 'TZ', value: '255' },
        { en: 'Thailand', label: '泰国', name: 'TH', value: '66' },
        { en: 'Timor-Leste', label: '东帝汶', name: 'TL', value: '670' },
        { en: 'Togo', label: '多哥', name: 'TG', value: '228' },
        { en: 'Tonga', label: '汤加', name: 'TO', value: '676' },
        { en: 'Trinidad and Tobago', label: '特立尼达和多巴哥', name: 'TT', value: '1868' },
        { en: 'Tunisia', label: '突尼斯', name: 'TN', value: '216' },
        { en: 'Turkey', label: '土耳其', name: 'TR', value: '90' },
        { en: 'Turkmenistan', label: '土库曼斯坦', name: 'TM', value: '993' },
        { en: 'Turks and Caicos Islands', label: '特克斯和凯科斯群岛', name: 'TC', value: '1649' },
        { en: 'Uganda', label: '乌干达', name: 'UG', value: '256' },
        { en: 'Ukraine', label: '乌克兰', name: 'UA', value: '380' },
        { en: 'United Arab Emirates', label: '阿拉伯联合酋长国', name: 'AE', value: '971' },
        { en: 'Uruguay', label: '乌拉圭', name: 'UY', value: '598' },
        { en: 'Uzbekistan', label: '乌兹别克斯坦', name: 'UZ', value: '998' },
        { en: 'Vanuatu', label: '瓦努阿图', name: 'VU', value: '678' },
        { en: 'Venezuela', label: '委内瑞拉', name: 'VE', value: '58' },
        { en: 'Vietnam', label: '越南', name: 'VN', value: '84' },
        { en: 'Virgin Islands, British', label: '英属处女群岛', name: 'VG', value: '1340' },
        { en: 'Virgin Islands, US', label: '美属维尔京群岛', name: 'VI', value: '1284' },
        { en: 'Yemen', label: '也门', name: 'YE', value: '967' },
        { en: 'Zambia', label: '赞比亚', name: 'ZM', value: '260' },
        { en: 'Zimbabwe', label: '津巴布韦', name: 'ZW', value: '263' }
      ]
    }
  },
  methods: {
    selectKey (value) {
      this.$emit('change', value)
    },
    getChecked (value1) {
      return Object.is(value1, this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.model {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  .model-body {
    border-radius: 16px 16px 0 0;
    position: fixed;
    top: 50vh;
    left: 0;
    height:50vh;
    background: #fff;
    box-shadow:0px -2px 12px 0px rgba(0,0,0,0.1);
    border-radius:16px 16px 0px 0px;
    box-sizing: border-box;
    padding: 0 24px;
    width: 100vw;
    .model-header {
      height:22px;
      font-size:17px;
      font-family:PingFangSC-Regular,PingFang SC;
      font-weight:400;
      color:rgba(60,60,67,0.6);
      line-height:22px;
      padding: 12px 0 8px 0;
      border-bottom: 1px solid #F2F2F7;
    }
    .model-content {
      height: calc(50vh - 46px);
      overflow-y: scroll;
      .model-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 18px 0;
        box-sizing: border-box;
        width: 100%;
        z-index: 999999;
        border-bottom: 1px solid #F2F2F7;
        span {
          font-size:17px;
          font-family:PingFangSC-Semibold,PingFang SC;
          font-weight: bold;
          color:rgba(51,51,51,1);
          line-height:22px;
        }
        .code {
          margin-left: 9px;
          font-weight: normal;
        }
      }
    }
  }
}
</style>
